(function () {
    'use strict';

    var $ = require('jquery');
    var $bannerSubTitle = $('.subtitle');

    if ($bannerSubTitle.length > 0) {

        var $subTitles = $('.subtitles [data-title]');
        var subTitles = [];

        $subTitles.each(function () {
            subTitles.push($(this).data('title'));
        });

        $('.subtitles').remove();

        //  Source: https://github.com/mattboldt/typed.js/blob/master/README.md
        $bannerSubTitle.typed({
            strings: subTitles,
            startDelay: 1500,
            typeSpeed: 100,
            loop: true,
            showCursor: false,
            shuffle: true
        });

    }

})();